import { resolveButtonStyle } from '../../../../shared/boxes/button/buttonStyles';
import classes from './CtaButton.module.css';

/**
 * Props d'apparence d'un `<Button>` Mantine, à partir des props de style d'un
 * bouton. Chaque comportement d'état est une classe posée seulement quand il
 * est réglé : un bouton qui ne porte ni `border` ni `buttonStyle` n'en reçoit
 * aucune et garde le rendu Mantine d'origine.
 *
 * Partagé par le CTA (un lien) et le bouton de connexion (une soumission de
 * formulaire), qui n'ont en commun que leur apparence.
 *
 * @returns {{
 *   buttonProps: Object, className: string, iconSide: string,
 *   pressAnimation: string,
 * }}
 */
export function buttonAppearance(styleProps, extraClassName = '') {
  const resolved = resolveButtonStyle(styleProps);

  const animation = {
    press: classes.press,
    lift: `${classes.lift} ${classes.hoverShadow}`,
    ripple: classes.ripple,
  }[resolved.pressAnimation];

  const className = [
    classes.cta,
    resolved.hoverColor ? classes.hoverBg : '',
    resolved.hoverFilter ? classes.hoverFilter : '',
    resolved.style['--btn-hover-shadow'] ? classes.hoverShadow : '',
    animation,
    extraClassName,
  ].filter(Boolean).join(' ');

  return {
    buttonProps: {
      size: resolved.size,
      variant: resolved.variant,
      color: resolved.color,
      gradient: resolved.gradient,
      style: resolved.style,
    },
    className,
    iconSide: resolved.iconSide,
    pressAnimation: resolved.pressAnimation,
  };
}

/**
 * Ondulation partant du point de clic. Écrit directement dans le DOM : un state
 * relancerait le rendu du bloc à chaque clic (§4 du README).
 */
export function startRippleOn(node, event) {
  if (!node) return;
  const rect = node.getBoundingClientRect();
  node.style.setProperty('--btn-ripple-x', `${event.clientX - rect.left}px`);
  node.style.setProperty('--btn-ripple-y', `${event.clientY - rect.top}px`);
  node.style.setProperty('--btn-ripple-size', `${Math.max(rect.width, rect.height) * 2}px`);
  node.classList.remove(classes.rippleActive);
  // Reflow forcé : sans lui, deux clics rapprochés ne rejouent pas l'animation.
  void node.offsetWidth;
  node.classList.add(classes.rippleActive);
}

export { classes as ctaButtonClasses };
